<template>
  <generic-container
    icon="linkify"
    :title="$t('short.io links')"
    :configurable="true"
    :show_plus="true"
    :show_refresh="true"
    v-bind:configure_modal="configure_modal"
    @add="add"
    @refresh="init"
  >
    <!-- <div class="ui form">
      <div class="three fields">
        <div class="field">
          <label>{{ $t("start date") }}</label>
          <div class="ui calendar" ref="range_start">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input
                type="text"
                :placeholder="$t('start date')"
                v-model="start_date"
              />
            </div>
          </div>
        </div>
        <div class="field">
          <label>{{ $t("end date") }}</label>
          <div class="ui calendar" ref="range_end">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input
                type="text"
                :placeholder="$t('end date')"
                v-model="end_date"
              />
            </div>
          </div>
        </div>
        <div class="field">
          <label>'</label>
          <div
            class="ui blue icon labeled fluid button"
            @click="get_verifications"
          >
            <i class="check icon"></i> {{ $t("get links") }}
          </div>
        </div>
      </div>
    </div> -->
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("original url") }}</th>
          <th>{{ $t("short.io url") }}</th>
          <!-- <th>{{ $t("data") }}</th> -->
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <link-modal ref="link_modal" @success="init" />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import {
  // local_api,
  init_ajax_data_datables,
  enterprise_setup,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import LinkModal from "./link_modal/Index.vue";

// @ is an alias to /src
export default {
  name: "OnfidoConnectIndex",
  components: {
    "generic-container": GenericContainer,
    LinkModal,
  },
  filters: filters,
  data() {
    return {
      configure_modal: ConfigureModal,
      datatable: {},
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    // get_verifications() {
    //   let vm = this;
    //   let ent_setup = enterprise_setup(vm);
    //   local_api(vm, "post", "/shortio/link/do-get-list", {
    //     s: vm.start_date,
    //     e: vm.end_date,
    //   })
    //     .then((verifications) => {
    //       vm.verifications = verifications;

    //       let columns = [
    //         {
    //           data: function(row) {
    //             // console.log(row);
    //             return filters.formatDate(
    //               row.create_date,
    //               ent_setup.detailed_date_format,
    //             );
    //           },
    //         },
    //         {
    //           data: function(row) {
    //             return JSON.stringify(row);
    //           },
    //         },
    //       ];
    //       let onSelect = function(data) {
    //         vm.show_verification_modal = true;
    //         setTimeout(() => {
    //           vm.$refs.verification_modal.updateVerification(data.uuid);
    //         }, 200);
    //       };
    //       let onCreatedRow = (tr, data) => {
    //         let $tr = window.jQuery(tr);
    //         if (data.check_result == "clear") {
    //           $tr.addClass("positive");
    //         } else if (data.check_result == "consider") {
    //           $tr.addClass("warning");
    //         }
    //       };

    //       init_json_local_data_datables(
    //         vm,
    //         vm.$refs.table,
    //         verifications,
    //         columns,
    //         onSelect,
    //         onCreatedRow,
    //         null,
    //       );
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       vm.$alertify.error(stringify(err));
    //     });
    // },
    add() {
      let vm = this;
      vm.$refs.link_modal.show_modal();
    },
    init() {
      let vm = this;
      let columns = [
        {
          data: function(row) {
            return filters.formatDate(
              row.create_date,
              vm.enterprise_setup.detailed_date_format,
            );
          },
        },
        {
          data: function(row) {
            return row.original_url;
          },
        },
        {
          data: function(row) {
            return row.short_url;
          },
        },
        // {
        //   data: function(row) {
        //     return JSON.stringify(row, null, 2);
        //   },
        // },
      ];

      let onSelect = (data) => {
        console.log(data);
        // vm.$refs.instance_modal.show_modal(data);
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["shortio url"],
        columns,
        onSelect,
      );
    },
  },
  created() {},
  mounted() {
    let vm = this;
    // setTimeout(() => {
    vm.init();
    // }, 500);
    // window.jQuery(vm.$refs.range_start).calendar({
    //   today: true,
    //   type: "datetime",
    //   endCalendar: window.jQuery(vm.$refs.range_end),
    //   onSelect(value) {
    //     vm.start_date = value;
    //   },
    // });
    // window.jQuery(vm.$refs.range_end).calendar({
    //   today: true,
    //   type: "datetime",
    //   startCalendar: window.jQuery(vm.$refs.range_start),
    //   onSelect(value) {
    //     vm.end_date = value;
    //   },
    // });
  },
  watch: {},
};
</script>
